module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center-b"
  }, [_c('span', [_c('i', [_vm._v("It shines in Paradise. It burns in Hell.")]), _c('br'), _vm._v("—Gaston Bachelard, "), _c('i', [_vm._v("The Psychoanalysis of Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_c('span', [_c('i', [_vm._v("I started hearing whispers from the people in the bedspread and in "), _c('br'), _vm._v("the window glass, and though I was a little embarrassed at first, I"), _c('br'), _vm._v("answered them, thinking, why deny anything?")]), _c('br'), _vm._v("—William S. Burroughs, Jr., "), _c('i', [_vm._v("Speed")])])]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_c('span', [_c('i', [_vm._v("The Bible never said anything about amphetamines")]), _vm._v("."), _c('br'), _vm._v("—“Fast” Eddie Felson in "), _c('i', [_vm._v("The Color of Money")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a81efd9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmater1.vue
// module id = 72
// module chunks = 0